import React from 'react';
import './WhyChooseUs.css'; // You might want to rename the CSS file

import { images, whyUs } from '../../../constants';
import { Heading } from '../../../components';

const WhyChooseUs = () => {

  const { sub, heading, content, points } = whyUs;

  return (
    <section className="why-us">
      {/* Why Choose Us Information */}
      <div className="box-container">
        {/* Why Us Content */}
        <div className="content">

          {/* Section Heading */}
          <Heading title={heading} subTitle={sub} sideHeading />

          {/* Description */}
          <p>{content}</p>

          {/* Why Us Points */}
          <div className="whyUs-points">

            <ul>
              {/* First two points */}
              {points.slice(0, 2).map((item) => (
                <li key={item.id}>
                  <div className="intro">
                    <div className='icon'>{item.icon}</div>
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.content}</p>
                </li>
              ))}
            </ul>

            <ul>
              {/* Next two points */}
              {points.slice(2, 4).map((item) => (
                <li key={item.id}>
                  <div className="intro">
                    <div className='icon'>{item.icon}</div>
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.content}</p>
                </li>
              ))}
            </ul>

          </div>

        </div>

        {/* Why Us Image */}
        <div className="image">
          <img src={images.whyUs} alt="Why Choose Us" />
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;